module.exports = __webpack_public_path__ + "9057fa72da2037f8a91f5c99011b5994.png";